import enContent from "@/content/i18n/en.json";
import msContent from "@/content/i18n/ms.json";
import zhContent from "@/content/i18n/zh.json";
import { type Locale } from "@/lib/i18n";

interface NavigationContent {
  labels: Record<string, string>;
  linkLabels: Record<string, string>;
}

const navigationContent: Record<Locale, NavigationContent> = {
  en: enContent.nav,
  ms: msContent.nav,
  zh: zhContent.nav,
};

export function getNavLabel(locale: Locale, label: string): string {
  return navigationContent[locale].labels[label] ?? label;
}

export function getNavLinkLabel(
  locale: Locale,
  href: string,
  fallback: string,
): string {
  return navigationContent[locale].linkLabels[href] ?? fallback;
}
